import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Editor, toHTML } from 'ngx-editor';
import { TestService } from 'src/app/services/test.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-email-texts',
  templateUrl: './email-texts.component.html',
  styleUrls: ['./email-texts.component.css']
})
export class EmailTextsComponent implements OnInit {

  @ViewChild('info') info: ElementRef;

  public editor:Editor;
  public html;
  
  public texts={
    creditsEmail: '',
    _id:"123456789987",
  };
  constructor(
    private testService:TestService,
    private userService: UserService
  ) {
    this.editor = new Editor();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
        this.html = resp.creditsEmail;

      },
      err=>console.log(err)
    )

  }

  update(){
    var html;
    if (this.html.type == "doc"){
      html = toHTML(this.html);
    }else{
      html = this.html;
    }
    this.texts.creditsEmail = html;
    let obj = {
      _id: this.texts._id,
      creditsEmail: html
    }
    this.testService.updateTexts(obj).subscribe(
      resp=>{
        Swal.fire('Actualizado');
      },
      err=>console.log(err)
    )
  }

  test(){
    this.userService.updateUser({
      email: 'daypoventas@yahoo.com.ar',
      remainingTests: 0
    }).subscribe(
      resp=>{
        Swal.fire('Usuario actualizado');
      }
      ,err=>{
        console.log(err);
        Swal.fire('Error al actualizar usuario');
      }
    )
  }

}
